export default __webpack_public_path__ + "static/media/clock.6f16e337.svg";